// extracted by mini-css-extract-plugin
module.exports = {"heroBackground":"Hero_heroBackground__1Q3Jl"};